import type { ContentType } from "@pdfking/pdfengine"

import { GuidToString, UInt8Hash } from "@pdfking/tfunc"
import { CreateRemoteFile } from "@pdfking/workflow/actions/pdfengine/Functions"

import type { FileObject } from "../types/FileObject"

import new_file_from_virtualfile from "./new_file_from_virtualfile"

// here we are creating a file from blob, we are doing this because
// caches quotas might be exceeded when uploading large files
// so we are bypassing quotas and storing the object in a blob url, obviously this file is transient
// to be improved.

export default async (transfer: File): Promise<FileObject> =>
  new_file_from_virtualfile({
    file: await CreateRemoteFile({
      guid: await transfer
        .arrayBuffer()
        .then(b => UInt8Hash([new Uint8Array(b)]))
        .then(GuidToString),
      mirrors: [URL.createObjectURL(transfer)],
      type: transfer.type as ContentType,
    }),
    path: transfer.name,
  })
